import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const DECRYPT_CRM_DATA = gql`
  query DecryptPersonalData($encryptedPersonalData: PersonalDataInput!) {
    decryptPersonalData(encryptedPersonalData: $encryptedPersonalData) {
      decryptedData
    }
  }
`;

/**
 * Apollo request
 */
const decryptCrmDataQuery = async ({ variables }) => {
  try {
    const decryptedData = await query({
      query: DECRYPT_CRM_DATA,
      variables,
    });

    return decryptedData.data.decryptPersonalData;
  } catch (error) {
    throw new Error('Could not get a CRM data', error);
  }
};

export default decryptCrmDataQuery;
